export default __webpack_public_path__ + "static/media/tv-dark.913bf2a8.png";